export default "__VITE_ASSET__556a7b53__"